module.exports = __webpack_public_path__ + "img/9.a2fc7d4f.jpg";